import PageMoveText from 'common-modules/general/Common/Components/Button/PageMoveText';
import { dataCalender } from 'data/generalOutline';
import { RoutesString } from 'common-modules/general/Config/routesString';

const CalenderSection = () => {
  return (
    <div id="calender" className="calender">
      <div className="calender-container">
        <div className="calender-container-title">
          <a>
            <PageMoveText link={`#${RoutesString.SalesInfo}`}>
              <h3>분양 일정</h3>
              <div className="arrow-right"></div>
            </PageMoveText>
          </a>
        </div>
        <div className="calender-list">
          {dataCalender.map((sp, index) => {
            return (
              <div key={index} className="calender-list-items">
                <div className="">
                  <div className="calender-date">{sp.date}</div>
                  <div className="calender-info">{sp.detail}</div>
                </div>
              </div>
            );
          })}
        </div>
        <div className="caution-text">
          * 인허가에 따라 일정은 변경될 수 있습니다.
        </div>
      </div>
    </div>
  );
};

export default CalenderSection;
